<template>
  <div>
    <top-bar title="Ajuda"/>
    <div class="mx-auto" style="max-width: 400px">
      <div class="container">
        <div v-if="!menu">
          <div>
            <a href="javascript:" aria-label="Excluir conta" class="d-flex py-4 text-dark border-bottom" @click="selMenu(1)" role="button">
              <div class="flex-grow-1 align-self-center">Alterar ou cancelar um pedido</div>
              <div class="align-self-center pr-3">
                <i class="fa fa-angle-right text-primary"></i>
              </div>
            </a>
            <a href="javascript:" aria-label="Alterar dados" class="d-flex py-4 text-dark border-bottom" @click="selMenu(2)" role="button">
              <div class="flex-grow-1 align-self-center">Alterar meus dados</div>
              <div class="align-self-center pr-3">
                <i class="fa fa-angle-right text-primary"></i>
              </div>
            </a>
            <router-link :to="url + '/excluir-conta'" aria-label="Excluir conta" class="d-flex py-4 text-dark border-bottom" @click="selMenu(3)" role="button">
              <div class="flex-grow-1 align-self-center">Excluir minha conta</div>
              <div class="align-self-center pr-3">
                <i class="fa fa-angle-right text-primary"></i>
              </div>
            </router-link>
          </div>
        </div>
        <div class="text-normal pt-4" v-else>
          <div v-if="menu === 1">
            <h6 class="font-weight-bold mb-3">Alterar ou cancelar um pedido</h6>
            <p>
              Seus pedidos que ainda não foram aceitos podem ser cancelados em "Pedidos" e, em seguida, "Cancelar o pedido".
            </p>
            <p>
              Para cancelar ou alterar pedidos que já foram aceitos, entre em contato com a gente pelo telefone: <a :href="'tel:' + empresa.telefone" class="text-primary font-weight-bold" aria-label="Telefone da empresa">{{empresa.telefone | maskPhone}}</a>.
            </p>
          </div>
          <div v-if="menu === 2">
            <h6 class="font-weight-bold mb-3">Alterar meus dados</h6>
            <p>
              Seus dados cadastrais podem ser alterados em "Perfil" e, em seguida, "Editar Dados".
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TopBar from "../components/TopBar";
  export default {
    name: 'Ajuda',
    components: {TopBar},
    data() {
      return {
        token: localStorage.getItem('token'),
        menu: 0,
        url: ''
      }
    },

    methods: {
      selMenu(menu) {
        this.menu = menu;
      },

      voltar() {
        if (this.menu) {
          this.menu = 0;

        } else {
          this.$router.go(-1)
        }
      }
    },

    mounted() {
      this.url = this.origin === '5' ? '/' + this.$store.state.empresa.dominio_delivery : '';
    },

    computed: {
      usuario() {
        return this.$store.state.dataUser
      },

      empresa() {
        return this.$store.state.empresa
      }
    },

    beforeRouteLeave(to, from, next) {
      if (this.menu) {
        this.menu = 0;
        next(false);

      } else {
        next()
      }
    },
  }
</script>

<style scoped>
</style>
